import React from 'react'
import styled, { keyframes } from 'styled-components'

import {
  MAX_SCREEN_CONTENT_WIDTH,
  MIN_SCREEN_WIDTH,
} from '@/components/templates/ScreenWrapper.tsx'
import { Header2 } from '@/components/Text.tsx'

const fadeInScale = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  50% {
    opacity: 0.8;
    transform: scale(1);
  }
  100% {
    opacity: 1;
  }
`

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 0.5s ease-out;
  max-width: 100%;
  min-width: ${MIN_SCREEN_WIDTH}px;
`

const Overlay = styled.button`
  background: rgba(0, 0, 0, 0.2);
  position: absolute;
  max-width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

const ModalWrapper = styled.div`
  max-width: ${MAX_SCREEN_CONTENT_WIDTH}px;
  background: ${({ theme }) => theme.colors.common.white};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  margin: 30px;
  width: 100%;
  gap: 16px;
  animation: ${fadeInScale} 0.3s ease-out;
  z-index: ${({ theme }) => theme.zIndex.modal};
`

const Modal = ({
  children,
  onClose,
  title,
}: {
  title: string
  children: React.ReactNode
  onClose: () => void
}) => {
  return (
    <Backdrop>
      <Overlay onClick={onClose} />
      <ModalWrapper>
        <Header2>{title}</Header2>
        {children}
      </ModalWrapper>
    </Backdrop>
  )
}

export { Modal }
